import { combineReducers } from "redux";
import LayoutReducer from "./LayoutReducer";
import CompanyReducer from "./CompanyReducer";
import adminReducer from "./AdminReducer";
import companyListReducer from "./CompanyListReducer";
import adminImagesReducer from "./AdminImagesReducer";

const RootReducer = combineReducers({
  layout: LayoutReducer,
  company: CompanyReducer,
  admin: adminReducer,
  companyList: companyListReducer,
  adminImages: adminImagesReducer  
});

export default RootReducer;
